module.exports = __webpack_public_path__ + "05_long_grey.d8d07580.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_long_grey.png
// module id = jdTJ
// module chunks = 0